import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, BookOpen } from 'lucide-react';
export function Product() {
  const tomos = [{
    num: 1,
    title: 'Fundamentos de IA para tu Negocio',
    subtitle: 'Base Instalada',
    color: 'bg-blue-900/30 border-blue-500/30',
    iconColor: 'text-blue-400',
    items: ['Qué es la IA sin tecnicismos.', 'ChatGPT desde cero para el emprendedor argentino.', 'Las 5 herramientas clave: ChatGPT, Canva IA, Gemini, Make y Otter.ai.', 'Tu primer prompt funcional en 10 minutos.', 'Quick Wins del primer día.', 'Casos reales de negocios argentinos.', 'Plan de 30 días de implementación.', 'Biblioteca de prompts iniciales.']
  }, {
    num: 2,
    title: 'ChatGPT para Ventas y Atención al Cliente',
    subtitle: 'Vendé Más sin Trabajar Más',
    color: 'bg-green-900/30 border-green-500/30',
    iconColor: 'text-green-400',
    items: ['El sistema completo de ventas por WhatsApp.', 'Scripts para cerrar ventas en Argentina.', "Manejo de objeciones locales: 'está caro', 'lo pienso', 'vi más barato'.", 'Automatización básica de atención.', 'Seguimiento y recuperación de ventas.', 'Fidelización de clientes con IA.', 'Prompts de venta listos para copiar y pegar.']
  }, {
    num: 3,
    title: 'IA para Marketing y Redes Sociales',
    subtitle: 'Presencia Constante sin Agotarte',
    color: 'bg-orange-900/30 border-orange-500/30',
    iconColor: 'text-orange-400',
    items: ['Estrategia de contenido con IA.', 'Calendario editorial mensual en 20 minutos.', 'Copies que venden para Instagram.', 'Guiones de Reels con IA.', 'Hashtags y horarios optimizados.', 'Publicidad paga con IA (Meta Ads).', 'Sistema de contenido evergreen.', 'Banco de 90 ideas de contenido listas.']
  }, {
    num: 4,
    title: 'Automatización de Procesos con IA',
    subtitle: 'El Negocio que Trabaja Solo',
    color: 'bg-red-900/30 border-red-500/30',
    iconColor: 'text-red-400',
    items: ['Make desde cero sin programar.', 'Flujo automático de WhatsApp 24/7.', 'Sistema de pedidos automatizado.', 'Integración con Mercado Pago.', 'Agenda y turnos automáticos.', 'Dashboard de negocio en tiempo real.', '5 automatizaciones listas para implementar.', 'Tu primer sistema autónomo en una semana.']
  }, {
    num: 5,
    title: 'IA para Finanzas y Precios en Argentina',
    subtitle: 'Controlá tu Dinero en Contexto Inflacionario',
    color: 'bg-yellow-900/30 border-yellow-500/30',
    iconColor: 'text-yellow-400',
    items: ['Sistema de costos con IA.', 'Precio correcto con margen real.', 'Estrategia de actualización por inflación.', 'Flujo de caja automatizado.', 'Análisis de rentabilidad por producto.', 'Predicciones financieras simples.', '10 prompts financieros listos.', 'Semáforo financiero de tu negocio.']
  }, {
    num: 6,
    title: 'Herramientas Avanzadas y Escalá tu Negocio',
    subtitle: 'El Siguiente Nivel',
    color: 'bg-purple-900/30 border-purple-500/30',
    iconColor: 'text-purple-400',
    items: ['Herramientas de IA avanzadas (Claude, Midjourney, HeyGen, Perplexity).', 'Chatbots inteligentes con IA.', 'Cómo escalar sin contratar más personal.', 'Estrategia de crecimiento a 12 meses.', 'Los 10 errores que destruyen negocios al escalar.', 'El futuro de la IA para emprendedores.', 'Plan de acción final y prompts avanzados.']
  }];
  const includes = ['Contenido 100% adaptado al contexto argentino', 'Ejemplos reales de negocios locales', 'Prompts listos para copiar y usar', 'Plan de implementación por semana', 'Casos de WhatsApp, Instagram y MP', 'Lenguaje sin tecnicismos', 'Ejercicios prácticos aplicables hoy', 'Conexión entre tomos (sistema progresivo)'];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-210">
      <div className="text-center mb-16" data-id="element-211">
        <h2 className="text-sm font-bold text-brand-gold tracking-widest uppercase mb-2" data-id="element-212">
          🏆 QUÉ ES EL MEGAPACK
        </h2>
        <h3 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-213">
          🤖 MEGAPACK IA EMPRENDEDORES™
        </h3>
        <p className="text-xl text-gray-300" data-id="element-214">
          6 Tomos + 6 Bonos — Todo resuelto para tu negocio argentino
        </p>
      </div>

      <div className="flex flex-wrap justify-center gap-2 mb-12" data-id="element-215">
        {['Bases', 'Ventas', 'Mktg', 'Auto', 'Fin', 'Escala'].map((tab, i) => <div key={i} className="px-4 py-2 bg-white/5 border border-white/10 rounded-lg text-sm font-medium text-gray-300" data-id="element-216">
            TOMO {i + 1}: {tab}
          </div>)}
      </div>

      <h4 className="text-2xl font-bold text-center text-white mb-10" data-id="element-217">
        📚 LOS 6 TOMOS COMPLETOS
      </h4>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-218">
        {tomos.map((tomo, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className={`border rounded-2xl p-6 ${tomo.color} relative overflow-hidden`} data-id="element-219">
            <div className="flex items-center gap-3 mb-4" data-id="element-220">
              <div className={`w-10 h-10 rounded-lg bg-black/20 flex items-center justify-center font-bold text-xl ${tomo.iconColor}`} data-id="element-221">
                {tomo.num}
              </div>
              <div data-id="element-222">
                <p className={`text-xs font-bold uppercase tracking-wider ${tomo.iconColor}`} data-id="element-223">
                  TOMO {tomo.num}
                </p>
                <h5 className="text-lg font-bold text-white leading-tight" data-id="element-224">
                  {tomo.title}
                </h5>
              </div>
            </div>
            <p className="text-sm font-medium text-gray-300 mb-4 pb-4 border-b border-white/10" data-id="element-225">
              {tomo.subtitle}
            </p>
            <ul className="space-y-2" data-id="element-226">
              {tomo.items.map((item, j) => <li key={j} className="flex items-start gap-2 text-sm text-gray-300" data-id="element-227">
                  <span className="mt-0.5 text-white/50" data-id="element-228">•</span>
                  <span data-id="element-229">{item}</span>
                </li>)}
            </ul>
          </motion.div>)}
      </div>

      <div className="bg-brand-violet/10 border border-brand-violet/30 rounded-2xl p-8 max-w-4xl mx-auto" data-id="element-230">
        <h4 className="text-xl font-bold text-white mb-6 text-center" data-id="element-231">
          ✅ Cada tomo incluye
        </h4>
        <div className="grid sm:grid-cols-2 gap-4" data-id="element-232">
          {includes.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-233">
              <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0" data-id="element-234" />
              <span className="text-gray-200" data-id="element-235">{item}</span>
            </div>)}
        </div>
      </div>
    </section>;
}